import React from 'react';
import { Box, Typography } from '@mui/material';
import { authFieldShellSx, authScreen } from './authScreenStyles';

type Props = {
  label: string;
  children: React.ReactNode;
  helperText?: React.ReactNode;
  htmlFor?: string;
};

export default function AuthField({ label, children, helperText, htmlFor }: Props) {
  return (
    <Box component="label" htmlFor={htmlFor} sx={{ display: 'block', mt: 2.25 }}>
      <Typography
        component="span"
        sx={{
          display: 'block',
          mb: 0.85,
          fontSize: '0.8125rem',
          fontWeight: 500,
          letterSpacing: '0.01em',
          color: authScreen.textMuted,
          fontFamily: authScreen.font,
        }}
      >
        {label}
      </Typography>
      <Box sx={authFieldShellSx}>{children}</Box>
      {helperText ? (
        <Box
          sx={{
            mt: 0.85,
            display: 'flex',
            alignItems: 'flex-start',
            gap: 0.65,
            color: authScreen.textDim,
            fontSize: '0.75rem',
            lineHeight: 1.5,
            fontFamily: authScreen.font,
          }}
        >
          {helperText}
        </Box>
      ) : null}
    </Box>
  );
}
